import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { WhatsAppChat } from './components/WhatsAppChat';
import { Home } from './pages/Home';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { Dashboard } from './pages/Dashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import { MainAdminDashboard } from './pages/MainAdminDashboard';
import { LimpopoAdminDashboard } from './pages/LimpopoAdminDashboard';
import { GautengAdminDashboard } from './pages/GautengAdminDashboard';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { getDomainContext } from './utils/domainAuth';
import { UserDashboard } from './pages/UserDashboard';
import { AdminOrders } from './pages/AdminOrders';
import { AdminProducts } from './pages/AdminProducts';
import { UserManagement } from './pages/UserManagement';
import { AdminHome } from './pages/AdminHome';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { DeliveryInfoPage } from './pages/DeliveryInfoPage';
import { FAQPage } from './pages/FAQPage';
import { OccasionsPage } from './pages/OccasionsPage';
import { BalloonsPage } from './pages/BalloonsPage';
import { FlowersPage } from './pages/FlowersPage';
import { GiftBoxesPage } from './pages/GiftBoxesPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ShopPage } from './pages/ShopPage';
// Wrapper component to handle root route logic
function RootRoute() {
  const {
    user,
    isLoading
  } = useAuth();
  if (isLoading) return <div data-id="element-0">Loading...</div>;
  if (user?.role === 'admin') {
    return <AdminHome data-id="element-1" />;
  }
  return <Home data-id="element-2" />;
}
function App() {
  return <AuthProvider data-id="element-3">
      <DataProvider data-id="element-4">
        <Router data-id="element-5">
          <Routes data-id="element-6">
            {/* Root Route - Shows AdminHome for admins, Home for others */}
            <Route path="/" element={<RootRoute data-id="element-8" />} data-id="element-7" />

            <Route path="/login" element={<LoginPage data-id="element-10" />} data-id="element-9" />
            <Route path="/signup" element={<SignupPage data-id="element-12" />} data-id="element-11" />
            <Route path="/about" element={<AboutPage data-id="element-14" />} data-id="element-13" />
            <Route path="/contact" element={<ContactPage data-id="element-16" />} data-id="element-15" />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-18" />} data-id="element-17" />
            <Route path="/delivery-info" element={<DeliveryInfoPage data-id="element-20" />} data-id="element-19" />
            <Route path="/faq" element={<FAQPage data-id="element-22" />} data-id="element-21" />
            <Route path="/occasions" element={<OccasionsPage data-id="element-24" />} data-id="element-23" />
            <Route path="/balloons" element={<BalloonsPage data-id="element-26" />} data-id="element-25" />
            <Route path="/flowers" element={<FlowersPage data-id="element-28" />} data-id="element-27" />
            <Route path="/gift-boxes" element={<GiftBoxesPage data-id="element-30" />} data-id="element-29" />
            <Route path="/favorites" element={<FavoritesPage data-id="element-32" />} data-id="element-31" />
            <Route path="/cart" element={<CartPage data-id="element-34" />} data-id="element-33" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-36" />} data-id="element-35" />
            <Route path="/shop" element={<ShopPage data-id="element-38" />} data-id="element-37" />

            {/* User Routes */}
            <Route path="/dashboard" element={<ProtectedRoute data-id="element-40">
                  <UserDashboard data-id="element-41" />
                </ProtectedRoute>} data-id="element-39" />

            {/* Main Admin Routes - Only accessible by main admin */}
            <Route path="/admin/main" element={<ProtectedRoute requireAdmin allowedRegions={['main']} data-id="element-43">
                  <MainAdminDashboard data-id="element-44" />
                </ProtectedRoute>} data-id="element-42" />

            {/* Limpopo Admin Routes - Accessible by main admin and Limpopo admin */}
            <Route path="/admin/limpopo" element={<ProtectedRoute requireAdmin allowedRegions={['main', 'limpopo']} data-id="element-46">
                  <LimpopoAdminDashboard data-id="element-47" />
                </ProtectedRoute>} data-id="element-45" />

            {/* Gauteng Admin Routes - Accessible by main admin and Gauteng admin */}
            <Route path="/admin/gauteng" element={<ProtectedRoute requireAdmin allowedRegions={['main', 'gauteng']} data-id="element-49">
                  <GautengAdminDashboard data-id="element-50" />
                </ProtectedRoute>} data-id="element-48" />

            {/* General Admin Routes - Accessible by all admins */}
            <Route path="/admin/dashboard" element={<ProtectedRoute requireAdmin data-id="element-52">
                  <AdminDashboard data-id="element-53" />
                </ProtectedRoute>} data-id="element-51" />
            <Route path="/admin/orders" element={<ProtectedRoute requireAdmin data-id="element-55">
                  <AdminOrders data-id="element-56" />
                </ProtectedRoute>} data-id="element-54" />
            <Route path="/admin/products" element={<ProtectedRoute requireAdmin data-id="element-58">
                  <AdminProducts data-id="element-59" />
                </ProtectedRoute>} data-id="element-57" />
            <Route path="/admin/users" element={<ProtectedRoute requireAdmin data-id="element-61">
                  <UserManagement data-id="element-62" />
                </ProtectedRoute>} data-id="element-60" />
          </Routes>

          {/* WhatsApp Chat Widget - Available on all pages */}
          <WhatsAppChat data-id="element-63" />
        </Router>
      </DataProvider>
    </AuthProvider>;
}
export { App };